// extracted by mini-css-extract-plugin
export var labelWrapper = "_bw-0";